import { Documents } from '@/components/beneficiary/Documents'
import { Document } from '@/store/document'
import { isNoteDocument } from '@repo/shared/utils'
import { useT } from '@repo/ui/hooks'
import { useMemo } from 'react'

export function BeneficiaryDocuments({
  allDocuments,
}: {
  allDocuments: Document[]
}) {
  const { t, tc } = useT({ keyPrefix: 'documents' })
  const documents = useMemo(
    () => allDocuments.filter((v) => !isNoteDocument(v)),
    [allDocuments],
  )
  return (
    <Documents
      description={t('documentDescription')}
      documents={documents}
      isFile
      title={tc('document', { count: 2, cfl: true })}
    />
  )
}
